export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./bk.vue?vue&type=template&id=d1cfe596&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/bk.vue?vue&type=template&id=d1cfe596&scoped=true
// module id = GdAV
// module chunks = 0